/*
  variant-auto-correct.js (VAST Sports)

  Zweck: Wechselt der Kunde die GROESSE und der aktuell gewaehlte Geschmack
  ist in der neuen Groesse nicht verfuegbar (existiert nicht oder ausverkauft),
  wird automatisch der erste verfuegbare Geschmack gewaehlt - statt
  "Nicht verfuegbar" anzuzeigen.

  WICHTIG: Die Korrektur greift NUR beim Groessenwechsel. Klickt der Kunde
  aktiv einen ausverkauften/durchgestrichenen Geschmack an, ist das
  beabsichtigt und "Nicht verfuegbar" bleibt stehen.

  Funktionsweise:
  - change-Listener in der CAPTURE-Phase auf document - laeuft damit VOR
    Dawns VariantSelects-Handler. Die Korrektur setzt die Geschmacks-Auswahl
    im selben Event um, Dawn liest danach die bereits korrigierte Auswahl
    und rendert die passende Variante (inkl. Preis/Promo-Box).
  - Varianten-Daten kommen aus dem JSON-Tag #AllVariants-{{ section.id }}
    in main-product.liquid ({"options": [...], "variants": [...]}).
  - PATCH (Dropdown-Fix): Dawn 15 liest die Auswahl ueber das
    [selected]-ATTRIBUT der Options (select option[selected]), nicht ueber
    die value-Property. setValue() zieht das Attribut deshalb mit um -
    sonst rendert Dawn trotz Korrektur die alte (nicht verfuegbare)
    Kombination und der Fallback korrigiert erst nach einem sichtbaren
    "Nicht verfuegbar"-Zwischenzustand.

  Einbindung (main-product.liquid):
  <script src="{{ 'variant-auto-correct.js' | asset_url }}" defer="defer"></script>
*/
(function () {
  'use strict';

  if (window.__variantAutoCorrectInit) return;
  window.__variantAutoCorrectInit = true;

  var TRIGGER_OPTIONS = ['größe', 'groesse', 'size'];

  function normalize(text) {
    if (!text) return '';
    return text.split(':')[0].replace(/\*/g, '').trim().toLowerCase();
  }

  function getOptionNameForControl(control) {
    var fieldset = control.closest('fieldset');
    if (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (legend) return normalize(legend.textContent);
    }
    var wrapper = control.closest('.product-form__input');
    if (wrapper) {
      var label = wrapper.querySelector('label');
      if (label) return normalize(label.textContent);
    }
    return '';
  }

  function collectControlsByOption(variantSelects, optionNames) {
    var map = {};

    variantSelects.querySelectorAll('fieldset').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var index = optionNames.indexOf(normalize(legend ? legend.textContent : ''));
      if (index > -1) map[index] = { type: 'radio', element: fieldset };
    });

    variantSelects.querySelectorAll('select').forEach(function (select) {
      var index = optionNames.indexOf(getOptionNameForControl(select));
      if (index > -1 && !map[index]) map[index] = { type: 'select', element: select };
    });

    return map;
  }

  function getSelectedValue(control) {
    if (!control) return null;
    if (control.type === 'select') return control.element.value;
    var checked = control.element.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function setValue(control, value) {
    if (!control) return;
    if (control.type === 'select') {
      control.element.value = value;
      /* Dawn 15 liest die Auswahl ueber das [selected]-Attribut
         (querySelectorAll('select option[selected]')) - die
         value-Property allein reicht nicht. Attribut mit umziehen: */
      for (var i = 0; i < control.element.options.length; i++) {
        var opt = control.element.options[i];
        if (opt.value === value) {
          opt.setAttribute('selected', 'selected');
        } else {
          opt.removeAttribute('selected');
        }
      }
      return;
    }
    var inputs = control.element.querySelectorAll('input');
    for (var j = 0; j < inputs.length; j++) {
      if (inputs[j].value === value) {
        inputs[j].checked = true;
        return;
      }
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.matches('input[type="radio"], select')) return;

      var variantSelects = input.closest('variant-selects');
      if (!variantSelects) return;

      var productInfo = input.closest('product-info');
      if (!productInfo || !productInfo.dataset.section) return;

      /* Nur beim Groessenwechsel korrigieren */
      var changedOption = getOptionNameForControl(input);
      if (TRIGGER_OPTIONS.indexOf(changedOption) === -1) return;

      var dataElement = document.getElementById('AllVariants-' + productInfo.dataset.section);
      if (!dataElement) return;

      var data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }

      var optionNames = (data.options || []).map(normalize);
      var variants = data.variants || [];
      if (!optionNames.length || !variants.length) return;

      var sizeIndex = -1;
      optionNames.forEach(function (name, index) {
        if (sizeIndex === -1 && TRIGGER_OPTIONS.indexOf(name) > -1) sizeIndex = index;
      });
      if (sizeIndex === -1) return;

      var controls = collectControlsByOption(variantSelects, optionNames);

      /* Aktuelle Auswahl einsammeln, neue Groesse aus dem Event uebernehmen */
      var selected = optionNames.map(function (_, index) {
        return getSelectedValue(controls[index]);
      });
      selected[sizeIndex] = input.value;

      /* Passt die aktuelle Kombination in der neuen Groesse? Dann nichts tun. */
      var combinationAvailable = variants.some(function (variant) {
        if (!variant.available) return false;
        return variant.options.every(function (value, index) {
          return selected[index] === null || value === selected[index];
        });
      });
      if (combinationAvailable) return;

      /* Erste verfuegbare Variante in der neuen Groesse suchen */
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available && variants[i].options[sizeIndex] === input.value) {
          fallback = variants[i];
          break;
        }
      }
      /* Ganze Groesse ausverkauft -> Dawn zeigt regulaer "Ausverkauft" */
      if (!fallback) return;

      /* Uebrige Optionen (Geschmack etc.) auf die Fallback-Variante umstellen.
         Das passiert VOR Dawns Handler - der liest anschliessend die bereits
         korrigierte Auswahl und rendert die verfuegbare Variante. */
      fallback.options.forEach(function (value, index) {
        if (index === sizeIndex) return;
        setValue(controls[index], value);
      });
    },
    true
  );
})();